import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { tscope } from '@i18n/index';
import { useDisclosure } from 'ui';
import { whatsAppContext } from './hooks';

const ts = tscope('Common.brand');

export const WhatsAppProvider = ({ children }) => {
  const [whatsAppNumber, setWhatsAppNumber] = useState(
    ts('whatsAppDocumentsNumber'),
  );
  const { isOpen, onOpen, onClose } = useDisclosure();

  const value = useMemo(() => ({
    isOpen,
    onOpen,
    onClose,
    whatsAppNumber,
    setWhatsAppNumber,
  }), [whatsAppNumber, setWhatsAppNumber, isOpen, onOpen, onClose]);

  return (
    <whatsAppContext.Provider value={value}>
      {children}
    </whatsAppContext.Provider>
  );
};

WhatsAppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
